import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";

searchWithinStyles.wrapper = mergeToNew(searchWithinStyles.wrapper, {
    css: css`
        background: ${getColor("secondary")};
        padding: 12px 15px;
        border-radius: 6px;
    `,
});

searchWithinStyles.titleText = mergeToNew(searchWithinStyles.titleText, {
    variant: "headerSecondary",
    color: "text.accent",
    css: css`
        margin-bottom: 7px;
        text-transform: capitalize;
        font-family: inherit;
    `,
});

searchWithinStyles.searchTextField = mergeToNew(searchWithinStyles.searchTextField, {
    cssOverrides: {
        formField: css`
            width: 100%;
            input {
                border-radius: 8px !important;
                padding-right: 35px !important;
            }
        `,
    },
});
